import React from 'react';

const OpacityLayer = ({ isShown, handleOnClick }) => {
  const classes = isShown ? 'opacity-layer' : 'opacity-layer--hidden';

  return <div className={classes} onClick={handleOnClick}></div>;
};

export default OpacityLayer;



// WEBPACK FOOTER //
// ./src/components/new/OpacityLayer.js